// Material Dashboard 2 React base styles
import colors from 'assets/theme/base/colors';
import typography from 'assets/theme/base/typography';

// Material Dashboard 2 React helper functions
import pxToRem from 'assets/theme/functions/pxToRem';

const { dark } = colors;
const { size, fontWeightBold } = typography;

const formControl = {
  styleOverrides: {
    root: {
      width: '100%',
      '.MuiInputBase-root': {
        paddingRight: 0,
      },
      '.MuiIconButton-edgeEnd': {
        right: '10px',
      },
      '& .MuiSelect-multiple': {
        paddingRight: '50px !important',
        textOverflow: 'ellipsis',
        whiteApace: 'nowrap',
        overflow: 'hidden',
        display: 'block',
        lineHeight: '48px',
      },
    },
  },
};

export default formControl;
